import React from 'react'

const Contact = () => {
  return (
    <div className='text-white pl-4 w-[90%] md:w-[80%] m-auto pt-10' id='contact'>
     <p className='text-4xl font-bold my-2'> Let's Connect 🤝🏻</p>
     <p className='ml-0 md:ml-4 text-[#08f8f0] my-4'>gupta.krishnalko111@gmail.com</p>

     <div className='text-center w-full text-yellow-500 mt-14 mb-[1rem]'>
        Designed and built by Krishna Gupta ✨
     </div>
    </div>
  )
}

export default Contact
